import React, { Component } from 'react';
import {
	ResponsiveContainer, Tooltip, Legend, CartesianGrid, XAxis, YAxis,
	LineChart, Line,
	Brush
} from 'recharts';
import BlockUi from 'react-block-ui';
import chartUtils, { COLORS, BLUE_COLORS, RED_COLORS } from '../../../common/services/chartUtils';
import { withTranslation } from 'react-i18next';
import './chartStyle.css';

// change line state on legend item hover
const LineState = {
	DEFAULT: 'default',
	HOVER: 'hover',
	DIMMED: 'dimmed',
	HIDDEN: 'hidden'
};

class TimelineChart extends Component {
	constructor(props) {
		super(props);
		this.handleLegendMouseEnter = this.handleLegendMouseEnter.bind(this);
		this.handleLegendMouseLeave = this.handleLegendMouseLeave.bind(this);
		this.handleLegendClick = this.handleLegendClick.bind(this);
		this.formatLegendItem = this.formatLegendItem.bind(this);

		this.state = {
			lineState: props.keys && props.keys.reduce((obj, key) => {
				obj[key] = LineState.DEFAULT;
				return obj;
			}, {})
		};
	}

	getColorsByKey(key) {
		if (key && key.startsWith('right.')) {
			return RED_COLORS;
		}
		else if (key && key.startsWith('left.')) {
			return BLUE_COLORS;
		}
		else {
			return COLORS;
		}
	}

	getResourceKey(name, key) {
		const resource = `${name}_${key}`;
		return resource.replace('.', '_');
	}

	handleLegendMouseEnter(o) {
		const { dataKey } = o;
		const { lineState } = this.state;

		Object.keys(lineState).forEach(x => {
			if (lineState[x] !== LineState.HIDDEN) {
				if (x === dataKey) {
					lineState[x] = LineState.HOVER;
				} else {
					lineState[x] = LineState.DIMMED;
				}
			}
		});

		this.setState({
			lineState: { ...lineState }
		});
	}

	handleLegendMouseLeave(o) {
		const { lineState } = this.state;

		Object.keys(lineState).forEach(x => {
			if (lineState[x] !== LineState.HIDDEN) {
				lineState[x] = LineState.DEFAULT;
			}
		});

		this.setState({
			lineState: { ...lineState }
		});
	}

	handleLegendClick(o) {
		const { dataKey } = o;
		const { lineState } = this.state;

		this.setState({
			lineState: { ...lineState, [dataKey]: lineState[dataKey] === LineState.HIDDEN ? LineState.HOVER : LineState.HIDDEN }
		});
	}

	renderLine(key, index) {
		const { name, t } = this.props;
		const colors = this.getColorsByKey(key);
		const lineState = this.state.lineState[key];

		let stroke = colors[index % colors.length];
		let strokeWidth = 1;

		switch (lineState) {
			case LineState.DIMMED:
				stroke = '#ccc';
				break;
			case LineState.HOVER:
				strokeWidth = 3;
				break;
			case LineState.HIDDEN:
				stroke = '#ccc';
				strokeWidth = 0;
				break;
		}

		return <Line type='monotone' isAnimationActive={false/*workaround for dots not showing*/} name={t(`${this.getResourceKey(name, key)}`)} key={index} dataKey={key}
			stroke={stroke} strokeWidth={strokeWidth} />;
	}

	formatLegendItem(value, entry) {
		const { dataKey } = entry;

		return <span style={this.state.lineState[dataKey] === LineState.HIDDEN ? { color: '#ccc' } : {}}>{value}</span>;
	}

	render() {
		const { loading, data, keys, name, height = 350, valueFormatter } = this.props;
		const timeSeriesChartMargin = { top: 10, right: 30, left: 0, bottom: 0 };

		const isMobileView = window.innerWidth < 768;
		const bottomLegendHeight = isMobileView ? keys.length * 28 : 0;

		return <BlockUi blocking={loading}>
			<ResponsiveContainer height={height + bottomLegendHeight}>
				<LineChart data={chartUtils.prepareTimeSeriesData(data)} margin={timeSeriesChartMargin}>
					<XAxis dataKey='timestamp' scale='time' type='number' domain={['dataMin', 'dataMax']} tickFormatter={chartUtils.formatUnixTime} />
					<YAxis axisLine={false} tickLine={false} tickFormatter={valueFormatter}/>
					<CartesianGrid vertical={false} />
					<Tooltip labelFormatter={label => chartUtils.formatUnixTime(label, 'll')} formatter={valueFormatter} />
					<Legend align={isMobileView ? 'center' : 'right'} verticalAlign={isMobileView ? 'bottom' : 'top'}
						layout='vertical' wrapperStyle={isMobileView ? { paddingTop: 15 } : { paddingLeft: 20, maxWidth: 270 }}
						formatter={this.formatLegendItem}
						onMouseEnter={this.handleLegendMouseEnter} onMouseLeave={this.handleLegendMouseLeave}
						onClick={this.handleLegendClick}
					/>
					{keys && keys.map((key, index) => this.renderLine(key, index))}
					{data && data.length > 0 && <Brush height={25} />}
				</LineChart>
			</ResponsiveContainer>
		</BlockUi>;
	}
}

export default withTranslation('formAnalytics.Melillo.resources')(TimelineChart);